import * as z from "zod";

const AgencySchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  logoUrl: z.string().nullable(),
  phoneNumbers: z.array(z.string()),
  website: z.string().nullable(),
});

const GetSchema = z.object({
  id: z.string(),
});

export const ClientAgency = {
  Agency: AgencySchema,
  Get: GetSchema,
};
export type ClientAgency = {
  Agency: z.infer<typeof AgencySchema>;
  Get: z.infer<typeof GetSchema>;
};
